<template>
  <div class="catalog-form">
    <h1>
      <i class="fal fa-arrow-circle-left" title="Regresar" @click="closeForm"></i>
      <span>{{ task.name }}</span>
      <div class="top-tool-bar flat actions pl-2">
        <div class="action d-none d-lg-block" v-if="permissionToRefresh" @click="refreshTask" title="Actualizar el estado de la tarea"><i class="fal fa-sync"></i> Refrescar</div>
        <div class="action d-none d-lg-block" :class="{ 'disabled': availableToCancel }" v-if="permissionToCancel" @click="cancelTask" title="Cancelar la tarea asíncrona"><i class="fal fa-trash-alt"></i> Cancelar</div>

        <div class="action d-lg-none d-xl-none" v-if="permissionToRefresh" @click="refreshTask" title="Actualizar el estado de la tarea"><i class="fal fa-sync"></i></div>
        <div class="action d-lg-none d-xl-none" :class="{ 'disabled': availableToCancel }" v-if="permissionToCancel" @click="cancelTask" title="Cancelar la tarea asíncrona"><i class="fal fa-trash-alt"></i></div>
      </div>
    </h1>

    <div class="menu-area hide-md">
      <div class="list-group">
        <a href="#generalInfo" class="list-group-item list-group-item-action">Información general</a>
        <a href="#attachments" class="list-group-item list-group-item-action"
          v-if="validateHasAttachments"
        >Archivos adjuntos</a>
        <a href="#history" class="list-group-item list-group-item-action">Actualizaciones</a>
      </div>
    </div>

    <div class="form-area">
      <div class="card mb-4" id="generalInfo">
        <div class="card-header">
          <p class="m-0">Información general</p>
          <span class="badge badge-primary">{{ task.taskType() }}</span>
        </div>
        <div class="card-body" v-if="task && task.id">
          <span class="task__id">ID: {{task.id}}</span>
          <p class="mb-1"><span class="font-weight-bold">Nombre:</span> {{task.name}}</p>
          <p class="mb-1"><span class="font-weight-bold">Estado:</span> <span class="badge badge-pill" :class="task.status">{{task.taskStatusTranslate() || task.status}}</span></p>
          <p class="mb-1"><span class="font-weight-bold">Template:</span> {{task.template.label}} [v{{task.template.version}}]</p>
          <div v-if="search && search.id" class="custom-search-details">
            <p class="custom-search-details__header detail-header"
              @click="showSearch = !showSearch">
              <i v-show="permissionToReadSearches && !showSearch" class="fas fa-caret-right"></i>
              <i v-show="permissionToReadSearches && showSearch" class="fas fa-caret-down"></i>
              Búsqueda <span class="text-muted font-weight-normal small">(ID: {{ search.id }})</span>
            </p>
            <div class="pl-3" v-show="showSearch">
              <p class="mb-1"><span class="font-weight-bold">Nombre:</span> {{ search.name }}</p>
              <p class="mb-1"><span class="font-weight-bold">Origen:</span> {{ searchType(search) }}</p>
              <p v-show="search.status" class="mb-1"><span class="font-weight-bold">Estado:</span> {{ search.status }}</p>
              <p v-show="search.worked" class="mb-1"><span class="font-weight-bold">Trabajado:</span> {{ search.worked ? 'Trabajados': 'No trabajados' }}</p>
              <p v-if="search.user && search.user.length" class="mb-1"><span class="font-weight-bold">Usuario:</span> {{ search.user.join(', ') }}</p>
              <p v-if="search.altUser && search.altUser.length" class="mb-1"><span class="font-weight-bold">AltUser:</span> {{ search.altUser.join(', ') }}</p>
              <p v-if="search.ident0 && search.ident0.length" class="mb-1"><span class="font-weight-bold">ident0:</span> {{ search.ident0.join(', ') }}</p>
              <p v-if="search.ident1 && search.ident1.length" class="mb-1"><span class="font-weight-bold">ident1:</span> {{ search.ident1.join(', ') }}</p>
              <p v-if="search.ident2 && search.ident2.length" class="mb-1"><span class="font-weight-bold">ident2:</span> {{ search.ident2.join(', ') }}</p>
              <p v-if="search.locationStatus" class="mb-1"><span class="font-weight-bold">Ubicación de estado:</span> {{ search.locationStatus }}</p>
              <div v-if="search.view && view && view.id" class="custom-view-details">
                <p v-show="search.view" class="custom-view-details__header detail-header"
                  @click="showView = !showView">
                  <i v-show="!showView" class="fas fa-caret-right"></i>
                  <i v-show="showView" class="fas fa-caret-down"></i>
                  Vista <span class="text-muted font-weight-normal small">(ID: {{ view.id }})</span>
                </p>
                <div class="pl-3" v-show="showView">
                  <p class="mb-1"><span class="font-weight-bold">Nombre:</span> {{ view.name }}</p>
                  <p class="mb-1"><span class="font-weight-bold">Predeterminada:</span> {{ view.predetermined ? 'Sí': 'No' }}</p>
                </div>
              </div>
              <div v-else-if="search.view">
                <p class="mb-1"><span class="font-weight-bold">Vista:</span> {{ search.view }}</p>
              </div>
              <p v-if="search.dateType" class="mb-1"><span class="font-weight-bold">Tipo de fecha:</span> {{ typeOfDate(search.dateType) }}</p>
              <p v-if="search.from" class="mb-1"><span class="font-weight-bold">Desde:</span> {{ toLocalDateString(search.from) }}</p>
              <p v-if="search.to" class="mb-1"><span class="font-weight-bold">Hasta:</span> {{ toLocalDateString(search.to) }}</p>
              <p v-if="search.values" class="mb-1"><span class="font-weight-bold">Configuración:</span> {{ search.values }}</p>
            </div>
          </div>
          <div v-else>
            <p class="mb-1"><span class="font-weight-bold">Búsqueda:</span> {{ task.process.search }}</p>
          </div>
          <p class="mb-1"><span class="font-weight-bold">Formato:</span> {{ downloadFormatTask }}</p>
          <div v-if="isDatafeedTask">
            <p class="mb-1"><span class="font-weight-bold">Encabezado:</span> {{task.process.header}}</p>
          </div>
          <div v-else-if="isIntegrationTask">
            <p class="mb-1"><span class="font-weight-bold">Origen:</span> {{task.process.source}}</p>
            <p class="mb-1"><span class="font-weight-bold">Zona horaria:</span> {{task.process.timeZone}}</p>
          </div>
          <div class="task__progress">
            <label class="task-progress__label" for="progress-bar">Progreso</label>
            <div class="task-progress__details" for="progress-bar">
              <span v-if="isDatafeedTask">Obtenidos: {{task.process.fetched}}</span>
              <span v-else-if="isIntegrationTask">Se integraron correctamente {{ task.process.successful }} de {{ task.process.total }}.</span>
              <span>Totales: {{task.process.total}}</span>
            </div>
            <div class="progress" id="progress-bar">
              <div class="progress-bar bg-info"
                :class="{'progress-bar-animated progress-bar-striped': task.percentage < 100 && validateTaskInProcess}"
                role="progressbar"
                :style="`width: ${taskPercentageString}%`"
                :aria-valuenow="taskPercentageString"
                aria-valuemin="0"
                :aria-valuemax="task.process.total">
                <span><i class="fad fa-line-columns mr-1"></i>{{ taskPercentageString }}%</span>
              </div>
            </div>
          </div>
          <small class="text-muted"><i class="fal fa-stopwatch"></i> Duración: {{task.duration}}</small>
          <!-- To show error details -->
          <div class="task__error" v-if="task.process && task.process.error">
            <span><i class="fas fa-exclamation-circle"></i></span><p class="task__error-header">Detalle del proceso:</p>
            <p class="task__error-detail">{{getErrorDetail}}</p>
          </div>
          <div v-if="isDatafeedTask">
            <a v-if="availableDownloadLinkForDatafeed"
              class="results-task-link" @click="redirectUrlResult" target="_blank"
            >
              Consultar archivo {{ downloadFormatTask }}
            </a>
            <p v-else class="text-muted m-0">Consultar archivo {{ downloadFormatTask }} (expirado)</p>
          </div>
        </div>
      </div>
      <div class="card mb-4" id="attachments" v-if="validateHasAttachments">
        <div class="card-header">
          Archivos adjuntos
        </div>
        <div class="card-body">
          <div class="task__progress-attachments" v-if="validateHasAttachments">
            <label class="task-progress__label" for="progressBarAttachments">Progreso de archivos adjuntos</label>
            <div class="task-progress__details" for="progressBarAttachments">
              <span>Obtenidos: {{task.process.attachmentProgress.fetched }}</span>
              <span>Totales: {{task.process.attachmentProgress.total}}</span>
            </div>
            <div class="progress" id="progressBarAttachments">
              <div class="progress-bar bg-secondary"
                :class="{'progress-bar-animated progress-bar-striped': task.attachmentPercentage < 100 && validateTaskInProcess}"
                role="progressbar"
                :style="`width: ${taskAttachmentPercentageString}%`"
                :aria-valuenow="taskAttachmentPercentageString"
                aria-valuemin="0"
                :aria-valuemax="task.process.attachmentProgress.total">
                <span><i class="fad fa-file-archive mr-1"></i>{{ taskAttachmentPercentageString }}%</span>
              </div>
            </div>
          </div>
          <small>Listado de los identificadores de los archivos adjuntos que fueron seleccionados para descargar</small>
          <ul class="attachment-list">
            <li v-for="(attachment, index) in task.process.attachmentIds" :key="`${index + attachment}`">
              {{ attachment }}
            </li>
          </ul>
        </div>
      </div>
      <div class="card mb-4" id="history" v-if="task && task.id">
        <div class="card-header">
          <p class="m-0">Actualizaciones</p>
          <span class="text-muted small">Request-Id: {{task.process.requestId}}</span>
        </div>
        <div class="card-body">
          <table class="table">
            <thead>
              <th>Evento</th>
              <th>Fecha</th>
            </thead>
            <tbody>
              <tr>
                <td>Creación</td>
                <td>{{task.getLocalCreationDate()}}</td>
              </tr>
              <tr>
                <td>Actualización</td>
                <td>{{task.getLocalUpdateDate()}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <LoadingMask :active="loading"/>
  </div>
</template>

<script lang="ts">
import { AsyncTask, AsyncTaskStatus, AsyncTaskType } from '@/types/catalogs/AsyncTask'
import LoadingMask from '@/components/generic/LoadingMask.vue'
import Vue from 'vue'
import FillgridService from '@/services/FillgridService'
import { CustomSearch, SearchDateType, SearchOrigin } from '@/types/catalogs/CustomSearch'
import { CustomView } from '@/types/catalogs/Views'
import CatalogsFillsService from '@/services/CatalogsFillsService'
import LogService from '@/services/support/LogService'

export default Vue.extend({
  components: {
    LoadingMask
  },
  props: {
    taskId: {
      type: Number,
      required: true
    },
    permissionToCancel: {
      type: Boolean,
      default: false
    },
    permissionToRefresh: {
      type: Boolean,
      default: false
    },
    permissionToReadSearches: {
      type: Boolean,
      default: false
    },
    permissionToReadViews: {
      type: Boolean,
      default: false
    },
    loadedSearches: {
      type: Object,
      default: () => {}
    },
    loadedViews: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      loading: false,
      task: new AsyncTask(),
      taskStati: AsyncTaskStatus,
      taskTypes: AsyncTaskType,
      search: {} as CustomSearch,
      showSearch: false,
      view: {} as CustomView,
      showView: false
    }
  },
  mounted () {
    this.loadTask()
  },
  updated () {
    this.loading = false
  },
  watch: {
    taskId (): void {
      this.loadTask()
    }
  },
  computed: {
    /**
     * Try to get the translation for the task error details
     * @returns the error translated or the original error
     */
    getErrorDetail (): string {
      if (this.task.process && this.task.process.error) {
        const error = this.task.process.error
        return error.description
      }
      return ''
    },
    /**
     * @returns true if the task could be canceled
     */
    availableToCancel (): boolean {
      const stati = [this.taskStati.NEW, this.taskStati.PROCESSING, this.taskStati.WAITING]
      return !stati.includes(this.task.status)
    },
    taskPercentageString (): string {
      if (this.task.percentage) {
        if (this.task.percentage.toString().includes('.')) return this.task.percentage.toFixed(2)
        else return this.task.percentage.toFixed(0)
      }
      return '0'
    },
    taskAttachmentPercentageString (): string {
      if (this.task.attachmentPercentage) {
        if (this.task.attachmentPercentage.toString().includes('.')) return this.task.attachmentPercentage.toFixed(2)
        else return this.task.attachmentPercentage.toFixed(0)
      }
      return '0'
    },
    isDatafeedTask (): boolean {
      return this.task.type === AsyncTaskType.DATAFEED
    },
    isIntegrationTask (): boolean {
      return this.task.type === AsyncTaskType.INTEGRATION
    },
    availableDownloadLinkForDatafeed (): boolean {
      return this.task.availableResultsLink()
    },
    validateHasAttachments (): boolean {
      return this.task.process !== undefined &&
        this.task.process.attachmentIds !== undefined &&
        this.task.process.attachmentIds.length > 0
    },
    validateTaskInProcess (): boolean {
      return this.task.status === AsyncTaskStatus.PROCESSING
    },
    downloadFormatTask (): string {
      return this.validateHasAttachments
        ? '.ZIP'
        : '.CSV'
    }
  },
  methods: {
    /**
     * Transform the string format of the task
     * from dd/mm/yy, hh:mm to yyyy-mm-ddThh:mm
     *
     * @param date with format dd/mm/yy, hh:mm
     * @return a string with the same date but in ISO string format
     */
    stringForDate (date: string): string {
      let dateAndTime = date.split(',').map((part: string) => part.trim()) // [dd/mm/yy, hh:mm]
      dateAndTime[0] = dateAndTime[0].split('/').reverse().join('-') // [yy-mm-dd, hh:mm]
      let fullDate = dateAndTime[0].split('-') // [yy, mm, dd]
      fullDate[0] = fullDate[0].padStart(4, '20') // [20yy, mm, dd]
      dateAndTime[0] = fullDate.join('-') // [yyyy-mm-dd, hh:mm]
      return dateAndTime.join('T')
    },
    closeForm (): void {
      this.$emit('close')
    },
    refreshTask (): void {
      this.loadTask()
      this.$emit('updateAsyncTask', this.task)
    },
    cancelTask (): void {
      this.$emit('cancel')
    },
    /**
     * Get the information of the search related to the asynctask
     */
    async getTask (): Promise<any> {
      await CatalogsFillsService.getAsyncTaskById(this.taskId)
        .then((task) => {
          this.task = AsyncTask.createInstance(task)
        })
        .catch((error) => {
          LogService.log(`Error al obtener la información de la búsqueda: ${error}`)
        })
    },
    /**
     * Load the current task info
     */
    loadTask (): void {
      this.loading = true
      this.getTask()
        .then(() => {
          this.loadSearchDetails()
        })
    },
    /**
     * Get the information of the search related to the asynctask
     */
    async getSearchDetail (): Promise<any> {
      this.search = {} as CustomSearch
      this.view = {} as CustomView
      if (this.task.process.search) {
        let localSearch = this.loadedSearches[this.task.process.search]
        if (localSearch) {
          this.search = localSearch
        } else {
          await FillgridService.getSearch(this.task.template.id, this.task.process.search)
            .then((search) => {
              this.search = search
              this.$emit('save-search', search)
            })
            .catch((error) => {
              LogService.log(`Error al obtener la información de la búsqueda: ${error}`)
            })
        }
      }
    },
    /**
     * Get the information of the view related to the search
     */
    async getViewDetail (): Promise<any> {
      if (this.search.view) {
        let localView = this.loadedViews[this.search.view]
        if (localView) {
          this.view = localView
          return Promise.resolve(0)
        } else {
          await FillgridService.getViewById(this.task.template.id, this.search.view)
            .then((view) => {
              this.view = view
              this.$emit('save-view', view)
            })
            .catch((error) => {
              LogService.log(`Error al obtener la información de la vista de la búsqueda: ${error}`)
            })
        }
      }
    },
    /**
     * If the usar has the required permissions to read searches, it loads the search info
     * also if has permissions to read views, it loads the view info
     */
    loadSearchDetails (): void {
      if (this.permissionToReadSearches) {
        this.getSearchDetail()
          .then(() => {
            if (this.permissionToReadViews) this.getViewDetail()
          })
      }
    },
    /**
     * @param search to check its type
     * @returns the type of a search
     */
    searchType (search: CustomSearch): string {
      return search.origin === SearchOrigin.DATAFEED
        ? 'Datafeed'
        : 'Fillgrid'
    },
    /**
     * @returns a local date string based on a date string
     */
    toLocalDateString (date: string): string {
      return new Date(date).toLocaleDateString('es-MX')
    },
    /**
     * @param type of the task date
     * @returns the translation of the type of the search date
     */
    typeOfDate (type: SearchDateType): string {
      return type === SearchDateType.CREATION
        ? 'Fecha de creación'
        : 'Fecha de actualización'
    },
    async redirectUrlResult () {
      await CatalogsFillsService.getResultByID(this.task.id)
        .then(response => {
          const url:string = response.url
          window.location.href = url
        }).catch(() => {
          this.$bvToast.toast('Lo sentimos, ocurrió un error al descargar los resultados.', {
            title: 'Error de descarga',
            variant: 'danger',
            toaster: 'b-toaster-top-right',
            autoHideDelay: 4500
          })
        })
    }
  }
})
</script>

<style lang="scss" scoped>
$new-task: var(--teal);
$processing-task: var(--cyan);
$done-task: var(--green);
$error-task: var(--red);
$waiting-task: var(--yellow);
$canceled-task: var(--gray);

span[class*='badge badge-pill'] {
  color: var(--white);
}

.badge.badge-pill.NEW {
  background-color: $new-task;
}
.badge.badge-pill.PROCESSING {
  background-color: $processing-task;
}
.badge.badge-pill.WAITING {
  background-color: $waiting-task;
  color: #584F32
}
.badge.badge-pill.DONE {
  background-color: $done-task;
}
.badge.badge-pill.ERROR {
  background-color: $error-task;
}
.badge.badge-pill.CANCELED {
  background-color: $canceled-task;
}
.task__id {
  font-size: 1.5rem;
  font-weight: bold;
}
div#generalInfo,
div#history {
  .card-header {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
  }
}
.detail-header {
  margin: 0;
  position: relative;
  font-weight: bold;
  border-radius: 4px;
  background-color: var(--light);
  cursor: pointer;
  &:hover {
    background-color: #eceff1;
  }
  & > i {
    padding: 4px 4px 0 0;
    text-align: center;
    min-width: 14px;
    position: absolute;
    left: -12px;
  }
}
.custom-search-details {
  padding: 0;
  transition-duration: 2s;
}
.task__progress-attachments,
.task__progress {
  .progress {
    height: 2rem;
  }
  .task-progress__label {
    font-weight: bold;
    margin: 0;
  }
  .task-progress__details {
    display: flex;
    justify-content: space-between;
    font-size: small;
    color: #6c757d // text-muted value;
  }
}
.task__error {
  padding: 0.5rem;
  border-radius: 4px;
  background-color: var(--light);
  p {
    margin: 0;
  }
  .task__error-header {
    margin: 0 0 0 0.5rem;
    display: inline-block;
    font-weight: bold;
  }
  .task__error-detail {
    padding: 0 0 0 1.5rem;
  }
}
div#attachments {
  .attachment-list {
    list-style: square;
    max-height: 20rem;
    overflow-y: auto;
    li {
      width: fit-content;
      margin: 0 0 2px 0;
      padding: 0 0.4rem;
      border-radius: 0.4rem;
      background-color: var(--light);
    }
  }
}
.results-task-link:hover {
  cursor: pointer;
}
</style>
